<template>
  <div class="KeyBoard">
    <!-- {{this.keyValue}} -->
    <div class="KeyBoard_box">
      <div class="box_number">
        <div v-for="(item,index) in keyList" :key="index" @touchstart.stop="handleKeyNum(item.val)">
          <button>{{item.key}}</button>
        </div>
      </div>
      <div class="box_btns">
        <div class="delete">
          <div class="ac_color" @touchstart.stop="handleDelete()">
            <button>
              <i class="iconfont icon-icon_jianpan_jianpanshanchu2x"></i>
            </button>
          </div>
          <slot name="diy_btn" class="diy_btn"></slot>
        </div>
        <div class="finish" :disabled="finish_disabled" @click.stop="finish_disabled?'':handleFinish()">
          <button>
            {{finish_text}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 参数:
 *  1. v-model: 绑定值
 *  2. k_finish_disabled: 完成按钮是否可用
 *  2. k_finish_text: 完成按钮文字
 *  3. k_decimal: 保留小数位数,Number型   默认: 2
 *  6. @finish(value): 输入框失焦事件, 回调参数 为绑定值
 *  6. @input(value): 输入框输入事件, 回调参数 为绑定值
 */
export default {
  name: "KeyBoardInput",
  model: {
    prop: "k_value",
    event: "setValue"
  },
  props: {
    k_value: "",
    k_decimal: {
      type: [String, Number],
      default: 2
    },
    k_finish_text: {
      type: [String, Number],
      default: "完成"
    },
    k_finish_disabled: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    k_value: {
      handler(newValue, oldValue){ 
        this.keyValue = newValue+'';
      },
      deep:true
    },
    k_decimal: {
      handler(newValue, oldValue){ 
        this.decimal = newValue
      },
      deep:true
    },
    k_finish_text: {
      handler(newValue, oldValue){
        this.finish_text = newValue
      },
      deep:true
    },
    k_finish_disabled: {
      handler(newValue, oldValue){
        this.finish_disabled = newValue
      },
      deep:true
    },
  },
  data() {
    return {
      keyList:[{key:1,val:1},{key:2,val:2},{key:3,val:3},{key:4,val:4},{key:5,val:5},{key:6,val:6},{key:7,val:7},{key:8,val:8},{key:9,val:9},{key:"AC",val:-1},{key:0,val:0},{key:"·",val:"."}],
      // prop 里的值
      value: this.k_value + "", // 用来存 输入后 的老值
      decimal: this.k_decimal,
      finish_text:this.k_finish_text,  // 完成按钮文字
      finish_disabled:this.k_finish_disabled,  // 完成按钮是否禁用

      // 页面的变量
      keyValue: "",
      // 非法值
      aIllegal: ["00","01","02","03","04","05","06","07","08","09","0..","."],

      keyValue:'',

    };
  },
  created() {
    
  },
  mounted() {},
  methods: {
    // 清空
    clear(){
      this.keyValue = ''
    },
    // 按下了按键 数字
    handleKeyNum(add_val){
      var audio_val = add_val 
      var old_val = this.keyValue
      // 如果输入了AC 把旧的值 变为 0
      if (add_val == "-1") {
        old_val = "";
        add_val = "0";
      }
      // 如果只有一个 0 的 话 且输入不是. 的话吧old_val置空
      if (old_val === "0" && add_val !== ".") {
        old_val = "";
      }

      var new_val = old_val + "" + add_val
      
      /*检验新值, 如果没有通过检测, 恢复值*/
      if (!this.passCheck(new_val)) {
        this.keyValue = old_val;
        return;
      }else{
        this.keyValue = new_val
      }
      var audio = ''
      if(audio_val == "-1"){
        audio = "归零"
      }else if(audio_val == "."){
        audio = "点"
      }else{
        audio = audio_val
      }
      this.$playaudio(audio)
      this.$emit("input", this.keyValue); // 将当前对象 evt 传递到父组件
    },
    // 按下了完成按钮
    handleFinish(){
      this.keyValue = Number(this.keyValue) + ""
      this.$emit("finish", this.keyValue);
    },
    // 通知父级
    // notify() {
    //   this.keyValue = this.keyValue;
    //   this.$emit("setValue", this.real_val);
    //   this.$emit("input", this.real_val); // 将当前对象 evt 传递到父组件
    // },
    // 删除按钮
    handleDelete() {
      /*删除值并不会触发值的校验, 所以需要手动再触发一次*/
      this.keyValue = this.keyValue.slice(0, -1);
      if(this.keyValue === ""){
        this.keyValue = '0'
      }
      this.$playaudio("清除")
      this.$emit("input", this.keyValue); // 将当前对象 evt 传递到父组件
    },
    passCheck(val) {
      /*验证规则*/
      let aRules = [this.illegalInput, this.illegalValue, this.accuracy];
      return aRules.every(item => {
        return item(val);
      });
    },
    /*非法输入*/
    illegalInput(val) {
      if (this.aIllegal.indexOf(val) > -1) {
        return false;
      }
      return true;
    },
    /*非法值*/
    illegalValue(val) {
      if (parseFloat(val) != val) {
        return false;
      }
      return true;
    },
    /*验证精度*/
    accuracy(val) {
      let v = val.split(".");
      if (v[0].length > this.inter) {
        return false;
      }
      if (v[1] && v[1].length > this.decimal) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.KeyBoard {
  width: 100%;
  position: relative;
  background-color: #d3d3d3;
  user-select: none;
  .KeyBoard_box{
    width: 100%;
    height: 3.34rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.06rem 0 0 0.06rem;
    .box_number{
      flex: 3;
      height: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &>div{
        flex: 1;
        flex-basis: 33%;
        padding: 0 0.06rem 0.06rem 0;
        button{
          display: block;
          width: 100%;
          height: 0.76rem;
          background-color: #fff;
          border-radius: 0.05rem;
          font-size: 0.36rem;
          font-weight: 500;
          color: #404040;
          &:active{
            background-color: #e1e1e1;
          }
        }
      }
    }
    .box_btns{
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      &>div{
        flex: 1;
        flex-basis: 50%;
        padding: 0 0.06rem 0.06rem 0;
        &[disabled]{
          button{
            background-color: #eee;
            color: #999;
            &:active{
              background-color: #eee;
            }
          }
        }
        &.delete{
          display: flex;
          flex-direction: column;
          &>div{
            flex-basis: 50%;
            flex: 1;
            &:nth-child(2){
              padding-top: 0.06rem;
              &[disabled]{
                button{
                  background-color: #eee;
                  color: #999;
                  &:active{
                    background-color: #eee;
                  }
                }
              }
            }
          }
        }
        button{
          display: block;
          width: 100%;
          height: 100%;
          background-color: #fff;
          border-radius: 0.05rem;
          font-size: 0.36rem;
          font-weight: 500;
          color: #404040;
          i{
            font-size: 0.36rem;
          }
          &:active{
            background-color: #e1e1e1;
          }
        }
        &.finish{
          min-height: 0.01rem;
        }
      }
    }
  }
  .ac_color{
    button{
      background-color: #48A1AF !important;
      color: #fff !important;
      &:active{
        background-color: #68b2bd !important;
      }
    }
  }
}
</style>